//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "PyramidChart",
  components: {},
  props: {
    alert: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    elements: {
      type: Array,
      default: () => [],
    },
    emptyMessage: {
      type: String,
      default: "",
    },
  },
  computed: {
    computedElements() {
      return this.elements.length
        ? this.elements
        : [
            { name: "", value: 400 },
            { name: "", value: 200 },
            { name: "", value: 100 },
            { name: "", value: 50 },
            { name: "", value: 25 },
          ];
    },
    isEmpty() {
      return !this.elements.length;
    },
    max() {
      return Math.max.apply(
        null,
        this.computedElements.map((element) => element.value),
      );
    },
  },
};
